import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  AppBar,
  Tabs,
  Tab,
  IconButton,
  ListItemText,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Select,
  OutlinedInput,
  InputLabel,
  MenuItem,
  Typography,
  TextField,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import Button from './Button';
import TabPanel from '../components/TabPanel';
import data from '../components/ProviderEditModal/data';
import {
  // updateProvider ,
  updateProviderUrlInfo,
} from '../services/api';
import {fetchAllProvidedUrls} from '../services/api/admin.js'

const splitUrl = url => {
  const splitUrl = url && url.split('/');
  return splitUrl && splitUrl[1];
};

function ProviderUrlEditModal(props) {
  const {
    provider,
    open,
    onClose,
    classes: { input },
  } = props;
  const [providerUrl, setProviderUrl] = useState(provider.profileUr || '');
  const [profileUrl, setProfileUrl] = useState(
    splitUrl(provider.providerUrl) || ''
  );
  const [buttonDisable, setButtonDisable] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [allProvidedUrls,setAllProvidedUrls]= useState([]);

  useEffect(() => {    
    const getUrls = async () => {
      const urls = await fetchAllProvidedUrls();
      setAllProvidedUrls(urls);
    };  
    getUrls();
    if (!!provider) {
      setProfileUrl(provider.profileUrl);
      setProviderUrl(splitUrl(provider.providerUrl));
    }
  }, []);

  const validate = () => {
    let valid = true;
    const nextState = {};
    if (!providerUrl) {
      nextState.providerUrl = 'Required';
      valid = false;
    }
    setValidationErrors(nextState);
    return valid;
  };

  const onSaveProviderUrl = async () => {
    setButtonDisable(true);
    await updateProviderUrlInfo({
      id: provider.id,
      providerUrl,
    });
    onClose();
    // setButtonDisable(false);
  };

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11}>
            <h2>{provider.name}</h2>
          </Grid>
          <Grid item xs={1}>
            <IconButton aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        <AppBar position="static" color="default">
          <Tabs value={0}>
            <Tab label="Provider Url" />
          </Tabs>
        </AppBar>

        <TabPanel>
          <Typography color="secondary">
            Warning: Changing an existing provider's Url (if they have one) will
            deprecate all links on the internet that points to that Url!
          </Typography>
          <DialogContent>
            <Typography variant="h4" gutterBottom="true">
              {provider.firstName + ' ' + provider.lastName}
            </Typography>
            <TextField
              disabled
              fullWidth
              variant="outlined"
              label="Existing Profile Url"
              value={profileUrl}
            />
            <FormControl fullWidth variant="outlined" className={input}>
              <InputLabel htmlFor="select">Provided Url</InputLabel>
              <Select
                fullWidth
                variant="outlined"
                label="Provided Url"
                name="providerUrl"
                value={providerUrl}
                onChange={event => {
                  setProviderUrl(event.target.value);
                  setValidationErrors({
                    ...validationErrors,
                    [event.target.name]: false,
                  });
                }}
                error={validationErrors.providerUrl}
                helperText={validationErrors.providerUrl}
                className={input}
              >
                {allProvidedUrls.map(specialtie => (
                  <MenuItem
                    key={`menu-${specialtie.shortName}`}
                    value={specialtie.shortName}
                  >
                    <ListItemText primary={specialtie.name} />
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {!providerUrl ? validationErrors.providerUrl : ''}
              </FormHelperText>
            </FormControl>
          </DialogContent>

          <Grid container justifyContent="flex-end">
            <Grid item xs={12} lg={6}>
              <Button
                onClickSuccessSnackbar="Url was sucessfully submitted."
                onClickFailSnackbar="Url could not be submitted"
                fullWidth
                color="primary"
                variant="contained"
                onClickValidation={validate}
                disabled={buttonDisable}
                onClick={onSaveProviderUrl}
              >
                Save Provider Url
              </Button>
            </Grid>
          </Grid>
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
}

const styles = () => ({
  input: {
    margin: '0.5em 0',
  },
});

ProviderUrlEditModal.propTypes = {
  provider: PropTypes.object,
  open: PropTypes.func,
  onClose: PropTypes.func,
  save: PropTypes.func,
};

export default withStyles(styles)(ProviderUrlEditModal);
